import type { ComponentType, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { cn } from './cn';
import { useScopedClassName } from './use-scoped-classnames';

export const injectClassName = <T extends { className?: string }>(
  Component: ComponentType<T>,
  suffix: string,
) => {
  const OutputComponent = forwardRef<ComponentRef<typeof Component>, T>(
    ({ className, ...props }, ref) => {
      const scopedClassName = useScopedClassName(suffix);

      return (
        // @ts-expect-error TS doesnt like ref
        <Component
          ref={ref}
          className={cn(className, scopedClassName)}
          {...props}
        />
      );
    },
  );

  return OutputComponent as unknown as ComponentType<T>;
};
